/* unplugin-vue-components disabled */import { render } from "./detail.vue?vue&type=template&id=78554fe7&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"

import "../../assets/css/springWater_detail.css?vue&type=style&index=0&id=78554fe7&scoped=true&lang=css&external"
import "./detail.vue?vue&type=style&index=1&id=78554fe7&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78554fe7"]])

export default __exports__